// import axios from "axios";
const BASE_URL = process.env.REACT_APP_BASE_URL;
const VERSION = process.env.REACT_APP_VERSION;
const baseUrl = `${BASE_URL}${VERSION}`;

export default baseUrl;
